/* ICExtract collection content — mobile read-more toggle only. Content stays in the DOM. */
(function () {
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('[data-ic-collection-content]'), function (section) {
    var toggle = section.querySelector('[data-ic-content-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var expanded = section.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded
        ? ((window.icStrings && window.icStrings.readLess) || 'Read less')
        : ((window.icStrings && window.icStrings.readMore) || 'Read more');
    });
  });
})();
